import React from 'react';

export const ReachLoader = ({ label = 'Finding your way…', fullScreen = false }) => {
  const content = (
    <div className="reach-loader" role="status" aria-live="polite" data-testid="reach-loader">
      <div className="reach-loader-track" aria-hidden="true">
        <div className="reach-loader-road" />
        <svg className="reach-loader-walker" viewBox="0 0 24 24" width="22" height="22">
          <circle cx="12" cy="4.6" r="2.4" className="reach-walker-ink" />
          <path
            d="M12 7.8 L12 13.8 M12 9.6 L8.8 12 M12 9.6 L15.2 12.4 M12 13.8 L9.2 19.4 M12 13.8 L14.8 19"
            className="reach-walker-stroke"
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
          />
        </svg>
        <svg className="reach-loader-pin" viewBox="0 0 24 24" width="20" height="20">
          <path d="M12 21.5s-6.8-6-6.8-10.7a6.8 6.8 0 1 1 13.6 0C18.8 15.5 12 21.5 12 21.5z" fill="#C87D3E" />
          <circle cx="12" cy="10.6" r="2.5" fill="#FAF8F5" />
        </svg>
      </div>
      <p className="reach-loader-label">{label}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen bg-[#FAF8F5] dark:bg-[#1C140D] flex items-center justify-center">
        {content}
      </div>
    );
  }
  return <div className="flex items-center justify-center py-16">{content}</div>;
};

export default ReachLoader;
